/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetTBAIAvailableQuarters200ResponseInner
 */
export interface GetTBAIAvailableQuarters200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetTBAIAvailableQuarters200ResponseInner
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof GetTBAIAvailableQuarters200ResponseInner
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof GetTBAIAvailableQuarters200ResponseInner
     */
    end: string;
    /**
     * 
     * @type {number}
     * @memberof GetTBAIAvailableQuarters200ResponseInner
     */
    quarter: number;
    /**
     * 
     * @type {number}
     * @memberof GetTBAIAvailableQuarters200ResponseInner
     */
    year: number;
}

/**
 * Check if a given object implements the GetTBAIAvailableQuarters200ResponseInner interface.
 */
export function instanceOfGetTBAIAvailableQuarters200ResponseInner(value: object): value is GetTBAIAvailableQuarters200ResponseInner {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('quarter' in value) || value['quarter'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    return true;
}

export function GetTBAIAvailableQuarters200ResponseInnerFromJSON(json: any): GetTBAIAvailableQuarters200ResponseInner {
    return GetTBAIAvailableQuarters200ResponseInnerFromJSONTyped(json, false);
}

export function GetTBAIAvailableQuarters200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTBAIAvailableQuarters200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'start': json['start'],
        'end': json['end'],
        'quarter': json['quarter'],
        'year': json['year'],
    };
}

export function GetTBAIAvailableQuarters200ResponseInnerToJSON(json: any): GetTBAIAvailableQuarters200ResponseInner {
    return GetTBAIAvailableQuarters200ResponseInnerToJSONTyped(json, false);
}

export function GetTBAIAvailableQuarters200ResponseInnerToJSONTyped(value?: GetTBAIAvailableQuarters200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'start': value['start'],
        'end': value['end'],
        'quarter': value['quarter'],
        'year': value['year'],
    };
}

